// import { User } from "firebase/auth";

import { createAction } from "shared/utils/redux/reduxUtils";
import { userActionTypes } from "./userActionTypes";
import { ThemeMode } from "./userReducer";

export const setCurrentThemeMode = (mode: ThemeMode) => createAction(userActionTypes.SET_CURRENT_THEME_MODE, mode);